import { transition } from '@helpers/animate';
import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { ButtonReset } from '@helpers/global';
import { Device, from, until } from '@helpers/media';
import ControlsStyles from '@stories/Components/Misc/Carousel/Controls/Controls.styles';
import SimpleTrackStyles from '@stories/Components/Misc/Carousel/SimpleTrack/SimpleTrack.styles';
import PinButtonStyles from '@stories/Components/PinButton/PinButton.styles';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled.div `
  display: grid;
  gap: 8px;

  @media ${from(Device.MobileLarge)} {
    grid-template-columns: 3fr 1fr;
    padding: 32px 0;
    gap: 16px;
  }
`;
const MainImageWrapper = styled.div `
  position: relative;

  ${PinButtonStyles.Button} {
    position: absolute;
    top: ${fluid(11, 15)};
    right: ${fluid(4, 8)};
  }
`;
const MainImageButton = styled.button `
  ${ButtonReset};
  ${imageWrapperPreserveRatio(16, 9)};

  display: block;
  cursor: zoom-in;

  svg[data-play] {
    ${transition('opacity')};

    position: absolute;
    color: ${brand.white};
    top: 50%;
    left: 50%;
    width: ${fluid(75, 105)};
    transform: translate(-50%, -50%);
    opacity: 0.7;
  }

  svg[data-zoom] {
    position: absolute;
    background-color: ${brand.green};
    padding: 8px;
    border-radius: 5000px;
    top: ${fluid(11, 15)};
    left: ${fluid(4, 8)};
    width: ${fluid(32, 44)};
    height: ${fluid(32, 44)};
  }

  &:hover svg[data-play] {
    opacity: 1;
  }
`;
const Image = styled(m.img) `
  ${imageCoverContainer()};

  [data-active='true'] & {
    border: 1px solid ${brand.green};
  }

  @media ${from(Device.MobileLarge)} {
    /** Ensure carousel doesn't overscroll by adding spacing above and below all images */
    height: calc(100% - 14px);
    top: 7px;
    bottom: 7px;
  }
`;
const ThumbnailWrapper = styled.div `
  display: none;

  @media ${from(Device.MobileLarge)} {
    display: flex;
    position: relative;
    z-index: 1;

    ${ControlsStyles.ButtonWrapper} {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      /** Ensure it doesn't impede the thumbnails */
      z-index: -1;
    }

    ${ControlsStyles.Button} {
      &[aria-label='Previous'] {
        transform: translateY(-75%);
      }

      &[aria-label='Next'] {
        transform: translateY(75%);
      }
    }

    &[data-count='1'],
    &[data-count='2'],
    &[data-count='3'] {
      ${ControlsStyles.Button} {
        display: none;
      }
    }
  }
`;
const ThumbnailWrapperMobile = styled.div `
  overflow: hidden;

  ${ControlsStyles.Container} {
    padding-left: calc(var(--sitePadding) * 0.5);
  }

  @media ${from(Device.MobileLarge)} {
    display: none;
  }
`;
const CarouselWrapper = styled.div `
  overflow: hidden;

  @media ${until(Device.MobileLarge)} {
    margin: 0 -4px;
  }

  @media ${from(Device.MobileLarge)} {
    max-height: var(--wrapperHeight);
    flex: 1;

    ${SimpleTrackStyles.Container} {
      max-height: var(--wrapperHeight);
    }
  }
`;
const CarouselItem = styled.li `
  @media ${until(Device.MobileLarge)} {
    flex: 0 0 25%;
    padding: 0 4px;
  }

  @media ${from(Device.MobileLarge)} {
    position: relative;
    height: 0;
    padding-bottom: calc(var(--wrapperHeight) / 3);
  }
`;
const CarouselImage = styled.button `
  ${ButtonReset};

  @media ${until(Device.MobileLarge)} {
    ${imageWrapperPreserveRatio(88, 63)};
    display: block;
  }
`;
const MediaGalleryStyles = {
    Container,
    MainImageWrapper,
    MainImageButton,
    Image,
    ThumbnailWrapper,
    ThumbnailWrapperMobile,
    CarouselWrapper,
    CarouselItem,
    CarouselImage,
};
export default MediaGalleryStyles;
